import React from 'react';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import popperImg from 'resources/img/popper.svg';
import puffuIcon from 'resources/img/puffuIcon.svg';
import appstore from 'resources/img/appstore.svg';
import galaxystore from "resources/img/galaxystore.png";
import onestore from "resources/img/onestore.png";
import P from 'components/P';
import Inline from 'layouts/container/Inline';

function AppDown() {
    const redirectToStore = (storeUrl) => {
        window.location.href = storeUrl;
    };

    const handleAppStoreClick = () => {
        const iosUrl = 'https://apps.apple.com/kr/app/puffu/id6504068927';
        redirectToStore(iosUrl);
    };

    const handleOneStoreClick = () => {
        const onestoreUrl = 'https://onesto.re/0000779461';
        redirectToStore(onestoreUrl);
    };

    const handleGalaxyStoreClick = () => {
        const galaxyStoreUrl = 'https://apps.samsung.com/appquery/appDetail.as?appId=com.puffu.puffupayment';
        redirectToStore(galaxyStoreUrl);
    };

    return (
        <Container height={"100dvh"}>
            <Container maxWidth={500}>
                <VerticalFlex gap={10}>
                    <FlexChild alignItems={"flex-end"} width={"100%"}>
                        <img src={popperImg} alt="Popper" />
                    </FlexChild>
                    <FlexChild>
                        <img src={puffuIcon} alt="Puffu Icon" />
                    </FlexChild>
                    <FlexChild height={"max-content"}>
                        <P size={"11vw"} weight={900} color={"rgba(254, 83, 31, 1)"}>반가워요!</P>
                    </FlexChild>
                    <FlexChild>
                        <P size={"6vw"}>24시간 언제나</P>
                        <P size={"6vw"}>간편한 무인 매장</P>
                        <Inline>
                            <P weight={"bold"} size={"6vw"} color={"var(--point-color)"}>푸푸</P>
                            <P size={"6vw"}>입니다</P>
                        </Inline>
                    </FlexChild>
                    <FlexChild height={"max-content"}>
                        <img src={appstore} alt="App Store" onClick={handleAppStoreClick} style={{ cursor: 'pointer' }} />
                    </FlexChild>
                    <FlexChild height={"max-content"}>
                        <img src={onestore} alt="One Store" onClick={handleOneStoreClick} style={{ cursor: 'pointer', width: '130px' }} />
                    </FlexChild>
                    <FlexChild height={"max-content"}>
                        <img src={galaxystore} alt="Galaxy Store" onClick={handleGalaxyStoreClick} style={{ cursor: 'pointer', width: '130px' }} />
                    </FlexChild>
                    <FlexChild />
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default AppDown; 